import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

// Config
import { Config } from '../../providers/config/config';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json; charset=UTF-8;'
  })
}

@Injectable()
export class RecertificationService {
  data: any;

  constructor( 
    public http: HttpClient
  ) {
  }

  getRecertifications()
  {
    return this.http.get( Config.API_ROOT_INSTRUCTORS + 'recertifications' )
      .pipe( map(this.processData, this) );
  }

  getRecertificationsByStatus( status = 'Pending' )
  {
    return this.http.get( Config.API_ROOT_INSTRUCTORS + 'recertifications?status=' + status )
      .pipe( map(this.processData, this) );
  }

  getRecertification( recertificationId )
  {
    return this.http.get( Config.API_ROOT_INSTRUCTORS + 'recertifications/' + recertificationId );
  }

  getRecertificationByInstructorId( instructorId )
  {
    return this.http.get( Config.API_ROOT_INSTRUCTORS + 'instructors/' + instructorId + '/recertifications' );
  }

  saveRecertification( recertification )
  {
    console.log(recertification);
    return this.http.put( Config.API_ROOT_INSTRUCTORS + 'recertifications/' + recertification.recertification_id, JSON.stringify(recertification), httpOptions );
  }

  deleteRecertification( recertificationId )
  {
    return this.http.delete( Config.API_ROOT_INSTRUCTORS + 'recertifications/' + recertificationId );
  }

  sendRecertificationRejectionEmail( recertificationId )
  {
    return this.http.get( Config.API_ROOT_INSTRUCTORS + 'recertifications/' + recertificationId + '/reject' )
  }

  searchRecertifications( search_term )
  {
    return this.http.get( Config.API_ROOT_INSTRUCTORS + 'recertifications?search=' + search_term )
      .pipe( map( this.processData, this ));
  }

  processData(data: any) 
  {
    this.data = data;

    if ( typeof this.data.length === 'undefined' )
    {
      this.data = this.setApplicationStatusColor( this.data );
    } else {
      let newData = [];
      this.data.forEach((item) => {
        item = this.setApplicationStatusColor( item );
        item.selected = false;
        newData.push( item );    
      });
      this.data = newData;
    }
    return this.data;
  } 

  setApplicationStatusColor( item )
  {
    switch ( item.status )
    {
      case 'Pending':
        item.ApplicationStatusColor = 'light-gray';
        break;
      case 'Approved':
        item.ApplicationStatusColor = 'success';
        break;
      case 'Rejected':
        item.ApplicationStatusColor = 'warning';
        break;  
      case 'Expired':
        item.ApplicationStatusColor = 'danger';
        break;
      default:
        item.ApplicationStatusColor = 'light-gray';
    }

    return item;
  }
}  


// WEBPACK FOOTER //
// ./src/providers/instructors/recertification-service.ts